import { store } from "./popup-behavior";
export function mountPopupElements(popup) {
	const timers = [];
	popup.querySelectorAll("[data-popup-countdown]").forEach((el) => {
		const update = () => {
			const remaining = new Date(el.dataset.popupCountdown) - Date.now();
			if (!Number.isFinite(remaining)) return;
			el.textContent =
				remaining <= 0
					? "Offer ended"
					: `${Math.floor(remaining / 86400000)}d ${
							Math.floor(remaining / 3600000) % 24
					  }h ${Math.floor(remaining / 60000) % 60}m ${
							Math.floor(remaining / 1000) % 60
					  }s`;
		};
		update();
		timers.push(setInterval(update, 1000));
	});
	popup.addEventListener("submit", (event) => {
		const form = event.target.closest("[data-popup-form]");
		if (form) {
			event.preventDefault();
			submit(popup, form, form.dataset.popupForm);
		}
	});
	popup.addEventListener("click", (event) => {
		const button = event.target.closest("[data-popup-action]");
		if (!button) return;
		const action = button.dataset.popupAction;
		if (action === "close") popup.close();
		if (["subscribe", "contact"].includes(action)) {
			const canvas = button.closest(".solufy-popup-design");
			if (
				[...canvas.querySelectorAll("input,textarea,select")].every((input) =>
					input.reportValidity()
				)
			)
				submit(popup, canvas, action);
		}
	});
	window.addEventListener("pagehide", () => timers.forEach(clearInterval), { once: true });
}
const pendingSubmissions = new WeakSet();
async function submit(popup, form, action) {
	if (pendingSubmissions.has(form)) return;
	const fields = [...form.querySelectorAll("input,textarea,select")];
	if (!fields.every((input) => input.reportValidity())) return;
	const payload = Object.fromEntries(
		fields
			.filter((input) => !["checkbox", "radio"].includes(input.type) || input.checked)
			.map((input) => [input.name, input.value])
	);
	const design = form.closest("[data-banner-name]");
	payload.design_id = design?.dataset.bannerName;
	payload.page = location.pathname;
	payload.referrer = document.referrer;
	const buttons = [...form.querySelectorAll("button")];
	pendingSubmissions.add(form);
	buttons.forEach((button) => (button.disabled = true));
	let status = form.querySelector("[data-popup-status]");
	if (!status) {
		status = document.createElement("small");
		status.dataset.popupStatus = "";
		status.setAttribute("role", "status");
		form.append(status);
	}
	status.textContent = "Sending…";

	const method =
		action === "subscribe"
			? "solufy_website.services.popup_submissions.subscribe"
			: "solufy_website.api.leads.create_lead";
	try {
		const response = await fetch("/api/method/" + method, {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				...(window.frappe?.csrf_token && window.frappe.csrf_token !== "None"
					? { "X-Frappe-CSRF-Token": window.frappe.csrf_token }
					: {}),
			},
			body: new URLSearchParams(payload),
		});
		const data = await response.json();
		if (!response.ok || !data.message?.ok) {
			let errMsg = "We could not submit this yet. Please try again.";
			if (data._server_messages) {
				try {
					const msgs = JSON.parse(data._server_messages);
					errMsg = msgs.map((m) => JSON.parse(m).message).join(" ");
				} catch {}
			} else if (data.message?.message) {
				errMsg = data.message.message;
			}
			throw new Error(errMsg);
		}
		status.textContent =
			action === "subscribe"
				? "Thank you for subscribing."
				: "Thank you. Our team will contact you shortly.";
		store("solufy_popup_converted_" + design?.dataset.bannerName, 1);
		document.dispatchEvent(
			new CustomEvent("solufy:form-result", { detail: { form, success: true } })
		);
	} catch (err) {
		status.textContent = err.message || "We could not submit this yet. Please try again.";
	} finally {
		pendingSubmissions.delete(form);
		buttons.forEach((button) => (button.disabled = false));
	}
}
